import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=40204522&scoped=true&"
import script from "./NewsArticle.vue?vue&type=script&lang=js&"
export * from "./NewsArticle.vue?vue&type=script&lang=js&"
import style0 from "./NewsArticle.vue?vue&type=style&index=0&id=40204522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40204522",
  null
  
)

export default component.exports